export const environment = {
  production: true,
  awsConfig: {
    historyS3Url: 'https://tooning-json-db.s3.ap-northeast-2.amazonaws.com/json-file/toonsquare-landing/toonsqaure-history-json',
    snsS3url: 'https://tooning-json-db.s3.ap-northeast-2.amazonaws.com/json-file/jsonData?v='
  },
  server_url: 'https://api.tooning.io'
};
